$(function(){
  initTooltips()

  document.addEventListener("turbo:before-visit", function () {
    console.log("Event:turbo:before-visit");
    // Hide all modals
    $('.modal').modal('hide');
    // Hide all tooltips
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        $(tooltipTriggerList).tooltip('hide');
    });
    $(".tooltip.show").hide();
  });
  document.addEventListener("turbo:load", function () {
    console.log("Event:turbo:load");
    // Hide existing tooltips that are still open from previous page
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        $(tooltipTriggerList).tooltip('hide');
    });
    $(".tooltip.show").hide();

    initTooltips();
  });
  document.addEventListener("turbo:frame-load", function () {
    console.log("Event:turbo:frame-load");
    // Hide existing tooltips that are still open from previous page
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        $(tooltipTriggerList).tooltip('hide');
    });
    $(".tooltip.show").hide();

    initTooltips();
  });
})

window.initTooltips = function(){
  console.log("initTooltips();");
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      if (!$(tooltipTriggerEl).data('tooltip-loaded')) {
          $(tooltipTriggerEl).data('tooltip-loaded',1);
          return new bootstrap.Tooltip(tooltipTriggerEl);
      }
  });
};